<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "line",
    data: {
        labels: [
            "Day 1",
            "Day 2",
            "Day 3",
            "Day 4",
            "Day 5",
            "Day 6",
            "Day 7",
            "Day 8",
            "Day 9",
            "Day 10",
            "Day 11",
            "Day 12",
            "Day 13",
            "Day 14",
            "Day 15",
            "Day 16",
            "Day 17",
            "Day 18",
            "Day 19",
            "Day 20",
            "Day 21",
            "Day 22",
            "Day 23",
            "Day 24",
            "Day 25",
            "Day 26",
            "Day 27",
            "Day 28",
            "Day 29",
            "Day 30",
        ],
        datasets: [
            {
                label: "Less Frequent Urinary Urges with Placebo",
                data: [
                    0, 0, 5, 5, 15, 15, 10, 20, 35, 30, 30, 25, 30, 25, 25, 30,
                    25, 30, 25, 25, 35, 25, 25, 25, 25, 25, 25, 25, 25, 25,
                ],
                backgroundColor: "rgba(252, 101, 133, 0.3)",
                borderColor: "rgba(252, 101, 133, 1)",
                borderWidth: 1,
                fill: true,
            },
            {
                label: "Less Frequent Urinary Urges with Prostacor",
                data: [
                    0, 6.67, 23.33, 43.33, 60, 66.67, 70, 80, 86.67, 93.33,
                    96.67, 90, 86.67, 93.33, 93.33, 96.67, 93.33, 93.33, 96.67,
                    90, 93.33, 86.67, 93.33, 96.67, 96.67, 90, 96.67, 93.33,
                    93.33, 90,
                ],
                backgroundColor: "rgba(24, 140, 251, 0.3)",
                borderColor: "rgba(24, 140, 251, 1)",
                borderWidth: 1,
                fill: true,
            },
        ],
    },
    options: {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value: number | string) {
                        return `${value}%`;
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"line">) {
                        return `${context.dataset.label?.includes("Prostacor") ? "Prostacor" : "Placebo"} - ${context.formattedValue}%`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
